import classNames from 'classnames';
import { FC } from 'react';

import styles from './HistogramImage.styles.m.css';

interface IHistogramImageProps {
  className?: string;
}

export const HistogramImage: FC<IHistogramImageProps> = ({ className }) => {
  return (
    <svg
      viewBox="0 0 188 24"
      xmlns="http://www.w3.org/2000/svg"
      className={classNames(className, styles.histogram)}
    >
      <g clip-path="url(#clip0_56939_8643)">
        <rect
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="4"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="8"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="12"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="16"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="20"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="24"
          y="18"
          width="2"
          height="6"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="28"
          y="18"
          width="2"
          height="6"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="32"
          y="4"
          width="2"
          height="20"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="36"
          width="2"
          height="24"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="40"
          width="2"
          height="24"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="44"
          width="2"
          height="24"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="48"
          y="6"
          width="2"
          height="18"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="52"
          y="10"
          width="2"
          height="14"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="56"
          y="15"
          width="2"
          height="9"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="60"
          y="19"
          width="2"
          height="5"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="64"
          y="9"
          width="2"
          height="15"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="68"
          y="18"
          width="2"
          height="6"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="72"
          width="2"
          height="24"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="76"
          y="1"
          width="2"
          height="23"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="80"
          y="3"
          width="2"
          height="21"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="84"
          y="16"
          width="2"
          height="8"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="88"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="92"
          y="18"
          width="2"
          height="6"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="96"
          y="13"
          width="2"
          height="11"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="100"
          y="4"
          width="2"
          height="20"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="104"
          y="6"
          width="2"
          height="18"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="108"
          y="15"
          width="2"
          height="9"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="112"
          y="15"
          width="2"
          height="9"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="116"
          y="9"
          width="2"
          height="15"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="120"
          y="13"
          width="2"
          height="11"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="124"
          y="15"
          width="2"
          height="9"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="128"
          y="9"
          width="2"
          height="15"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="132"
          y="9"
          width="2"
          height="15"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="136"
          y="10"
          width="2"
          height="14"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="140"
          y="4"
          width="2"
          height="20"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="144"
          y="7"
          width="2"
          height="17"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="148"
          y="15"
          width="2"
          height="9"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="152"
          y="18"
          width="2"
          height="6"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="156"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="160"
          y="15"
          width="2"
          height="9"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="164"
          y="6"
          width="2"
          height="18"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="168"
          y="10"
          width="2"
          height="14"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="172"
          y="16"
          width="2"
          height="8"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="176"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="180"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
        <rect
          x="184"
          y="21"
          width="2"
          height="3"
          rx="1"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_56939_8643">
          <rect
            width="188"
            height="24"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
